import { useDeleteHospital, useGetAllHospitals } from '_api';
import { useMemo } from 'react';

const useHospitals = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { mutateAsync: deleteHospital } = useDeleteHospital();
  const { data: allHospitals, isFetching: isLoading } = useGetAllHospitals({
    page,
    size,
  });

  const activeHospitals =
    allHospitals && allHospitals.filter((x) => x.status === 'ACTIVE');
  const archiveHospitals =
    allHospitals && allHospitals.filter((x) => x.status === 'DELETED');

  const hospitalOptions = useMemo(
    () =>
      allHospitals
        ? allHospitals.map((hospital) => ({
            description: hospital.name,
            name: hospital.id,
          }))
        : [],
    [allHospitals],
  );

  return {
    activeHospitals,
    allHospitals,
    archiveHospitals,
    deleteHospital,
    hospitalOptions,
    isLoading,
  };
};

export default useHospitals;
